<template>
	<div>
		<div ref="stickyBar" :class="{ 'sticky-action-bar': true, 'is-fixed': stickyBarFixed }">
			<el-row class="margin-top-lg">


				<el-col :span="23" class="text-right">

					<el-button type="primary" size="small" v-if="hasPrivilege('502020082314267912')"
						@click="openBatchPayRoomFeeModal">
						<i class="el-icon-plus"></i>
						缴费
					</el-button>
					<el-button type="warning" size="small" v-if="hasPrivilege('502020082314267912')"
						@click="openTempFeePayModal">
						<i class="el-icon-money"></i>
						补充缴费
					</el-button>
					<el-button type="primary" size="small" v-if="hasPrivilege('502022073096990007')"
						@click="openRoomCreateFeeAddModal">
						<i class="el-icon-plus"></i>
						{{ $t('simplifyRoomFee.createFee') }}
					</el-button>
					<el-button type="primary" size="small" @click="toOwnerPayFee">
						<i class="el-icon-plus"></i>
						{{ $t('simplifyRoomFee.arrearsPayment') }}
					</el-button>
				</el-col>
			</el-row>



			<div style="text-align: left;">
				<el-radio-group v-model="viewMode" size="small" style="margin-right: 20px;">
					<el-radio-button label="month">按月展示</el-radio-button>
					<el-radio-button label="year">按年展示</el-radio-button>
				</el-radio-group>
				<el-checkbox v-if="viewMode === 'month'" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
					全选/取消全选
				</el-checkbox>
				<el-checkbox v-if="viewMode === 'year'" :indeterminate="isYearIndeterminate" v-model="yearCheckAll" @change="handleYearCheckAll">
					全选/取消全选
				</el-checkbox>
				<span v-if="viewMode === 'month'" style="margin-left: 20px; color: #666;">
					已选择 {{ multipleSelection.length }} 个月份
				</span>
				<span v-if="viewMode === 'year'" style="margin-left: 20px; color: #666;">
					已选择 {{ yearSelection.length }} 年
				</span>
			</div>

			<el-alert v-if="hasHistoricalUnpaid" type="warning" show-icon :closable="false" style="margin-top: 10px;">
				<span slot="title">
					注意：检测到跳月缴费记录，存在已缴至日期前仍未缴纳的历史欠费月，请核实并尽快处理。
				</span>
			</el-alert>
		</div>

		<!-- 占位元素，固定时撑开高度防止内容跳动 -->
		<div v-show="stickyBarFixed" class="sticky-bar-placeholder"></div>

		<div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'MONTH' && viewMode === 'month'">

			<el-checkbox-group v-model="multipleSelection" @change="handleMonthSelectionChange">

				<div v-for="(monthData, month) in simplifyRoomFeeInfo.monthFees" :key="month" class="month-section">
					<div style="height: 30px; background-color:antiquewhite;text-align: left; font-size: 15px ;">
						<el-checkbox size="medium" style="height: 17px; width: 17px;font-size: 18px;" :label="month"
							:value="month" class="box"></el-checkbox>

						<label style="padding-left: 30px;">(共 {{ monthData.length }} 条记录,
							合计金额(元)：{{ getMonthTotal(monthData) }} 元)</label>
					</div>
					<el-table :data="monthData" :summary-method="getSummaries" show-summary style="width: 100%;" border
						stripe>

						<el-table-column prop="feeName" :label="$t('simplifyRoomFee.feeItem')" align="center">
							<template slot-scope="scope">
								<span class="hand" @click="viewRoomFeeConfig(scope.row)">
									{{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
								</span>
							</template>
						</el-table-column>
						<el-table-column prop="feeFlagName" :label="$t('simplifyRoomFee.feeFlag')"
							align="center"></el-table-column>
						<el-table-column prop="feeTypeCdName" :label="$t('simplifyRoomFee.feeType')"
							align="center"></el-table-column>
						<el-table-column :label="$t('simplifyRoomFee.chargeYearMonth')" align="center">
							<template slot-scope="scope">
								{{ scope.row.detailYear }}-{{ scope.row.detailMonth }}
							</template>
						</el-table-column>
						<el-table-column prop="receivableAmount" :label="$t('simplifyRoomFee.receivableAmount')"
							align="center"></el-table-column>
						<el-table-column :label="$t('simplifyRoomFee.description')" align="center" width="150">
							<template slot-scope="scope">
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.preDegrees') }}</span>{{ scope.row.preDegrees }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.curDegrees') }}</span>{{ scope.row.curDegrees }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ getOnePrice1(scope.row) }}
								</div>
								<div
									v-if="scope.row.computingFormula == '5005' || scope.row.computingFormula == '9009'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390006') }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
								</div>
								<div v-else-if="scope.row.computingFormula == '6006'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else-if="scope.row.feeTypeCd == '888800010017'">
									<span>{{ $t('simplifyRoomFee.algorithm') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390005') }}
								</div>
								<div v-else-if="scope.row.feeTypeCd == '888800010017'">
									<span>{{ $t('simplifyRoomFee.usage') }}</span>{{ getAttrValue(scope.row.feeAttrs, '390003') }}
								</div>
								<div v-else>
									<span>{{ $t('simplifyRoomFee.unitPrice') }}</span>{{ scope.row.squarePrice }}
								</div>
								<div v-if="scope.row.feeFlag == '1003006'">
									<span>{{ $t('simplifyRoomFee.additionalFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
								<div v-else>
									<span>{{ $t('simplifyRoomFee.fixedFee') }}</span>{{ scope.row.additionalAmount }}
								</div>
							</template>
						</el-table-column>

						<el-table-column :label="$t('simplifyRoomFee.operation')" align="center" width="200">
							<template slot-scope="scope">

								<el-button type="text" @click="payFeeHis(scope.row)">
									{{ $t('simplifyRoomFee.paymentHistory') }}
								</el-button>
								<el-dropdown
									v-if="hasPrivilege('502020090604200029') || hasPrivilege('502021070488970005') || hasPrivilege('502020090427190001')">
									<span class="el-dropdown-link">
										{{ $t('simplifyRoomFee.moreOperations') }}<i
											class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item v-if="hasPrivilege('502020090604200029')"
											@click.native="deleteFee(scope.row)">
											{{ $t('simplifyRoomFee.cancelFee') }}
										</el-dropdown-item>
            <el-dropdown-item v-if="hasPrivilege('502021070488970005')" @click.native="finishFee(scope.row)">
                  {{ $t('simplifyRoomFee.manualEnd') }}
                </el-dropdown-item>

										
										<el-dropdown-item>
											<a target="_blank"
												:href="'/#/views/fee/feeDetail?feeId=' + scope.row.feeId">
												{{ $t('simplifyRoomFee.details') }}
											</a>
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-checkbox-group>
		</div>

		<!-- 按年展示视图 -->
		<div class="margin-top" v-show="simplifyRoomFeeInfo.showFlag == 'MONTH' && viewMode === 'year'">
			<div v-for="(yearData, year) in yearFees" :key="year" class="year-section" style="margin-bottom: 15px;">
				<div style="height: 35px; background-color: #e8f4fd; padding: 0 10px; line-height: 35px; font-size: 16px; font-weight: bold;">
					<el-checkbox :value="yearChecked[year]" @change="handleYearSelectionChange(year, $event)" style="margin-right: 8px;"></el-checkbox>
					<i class="el-icon-date" style="margin-right: 8px;"></i>
					{{ year }} 年
					<span style="float: right; font-weight: normal; color: #666;">
						共 {{ yearData.monthCount }} 个月，
						合计：{{ yearData.yearTotal }} 元
					</span>
				</div>
				<el-table :data="yearData.records" border stripe style="width: 100%;">
					<el-table-column prop="feeName" label="费用项" align="center">
						<template slot-scope="scope">
							<span class="hand" @click="viewRoomFeeConfig(scope.row)">
								{{ scope.row.feeName }}{{ getSimplifyRoomFeeRoomName(scope.row) }}
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="feeTypeCdName" label="费用类型" align="center" width="120"></el-table-column>
					<el-table-column prop="timeRange" label="费用时间" align="center" width="180"></el-table-column>
					<el-table-column prop="monthCount" label="月数" align="center" width="80"></el-table-column>
					<el-table-column prop="totalAmount" label="总金额(元)" align="center" width="120"></el-table-column>
					<el-table-column label="操作" align="center" width="120">
						<template slot-scope="scope">
							<el-button type="text" @click="payFeeHis(scope.row)">缴费历史</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<el-row>
			<el-col :span="12" class="text-left table-desc">
				<div>{{ $t('simplifyRoomFee.note1') }}</div>
				<div>{{ $t('simplifyRoomFee.note2') }}</div>
			</el-col>
			<el-col :span="6">
				<span>
					<span>小计：</span>{{ simplifyRoomFeeInfo.totalAmount }}
				</span>
			</el-col>
		</el-row>
		<!-- Modal Components -->
		<delete-fee ref="deleteFee" @success="handleNotify"></delete-fee>
		<edit-fee ref="editFee" @success="handleNotify"></edit-fee>
		<temp-import-room-fee ref="tempImportRoomFee" @success="handleNotify"></temp-import-room-fee>
		<room-create-fee-add ref="roomCreateFeeAdd" @success="handleNotify"></room-create-fee-add>
		<add-meter-water ref="addMeterWater" @success="handleNotify"></add-meter-water>
		<add-proxy-fee ref="addProxyFee" @success="handleNotify"></add-proxy-fee>
		<finish-fee ref="finishFee" @success="handleNotify"></finish-fee>
		<temp-fee-pay ref="tempFeePay" @success="handleNotify"></temp-fee-pay>
	</div>
</template>


<script>
	import {
		listFee,
		listFeeConfigs,
		listMonthFee,
		groupByYearMonthWithMap
	} from '@/api/fee/simplifyRoomFeeApi'
	import {
		getDict
	} from '@/api/community/communityApi'
	import {
		getCommunityId
	} from '@/api/community/communityApi'
	import TempImportRoomFee from './tempImportRoomFee'
	import {
		dateFormat
	} from '@/utils/dateUtil'
	import DeleteFee from '@/components/fee/deleteFee'
	import EditFee from '@/components/fee/editFee'
	import RoomCreateFeeAdd from '@/components/fee/roomCreateFeeAdd'
	import AddMeterWater from '@/components/fee/addMeterWater'
	import AddProxyFee from '@/components/fee/addProxyFee'
	import FinishFee from '@/components/fee/finishFee'
	import TempFeePay from '@/components/fee/tempFeePay'

	export default {
		name: 'SimplifyRoomFee',
		components: {
			TempImportRoomFee,
			DeleteFee,
			EditFee,
			RoomCreateFeeAdd,
			AddMeterWater,
			AddProxyFee,
			FinishFee,
			TempFeePay
		},
		data() {
			return {
				simplifyRoomFeeInfo: {
					total: 0,
					records: 1,
					fees: [],
					monthFees: [],
					roomId: '',
					roomName: '',
					name: '',
					floorNum: '',
					unitNum: '',
					roomNum: '',
					configId: '',
					feeTypeCds: [],
					feeTypeCd: '',
					state: '2008001',
					totalAmount: 0.0,
					roomType: '',
					ownerFee: 'N',
					ownerId: '',
					showFlag: 'MONTH',
					feeConfigs: [],
					haveHistory: false
				},

				currentPage: 1,
				pageSize: 24,
				total: 0,
				multipleSelection: [],
				checkAll: false,
				viewMode: 'month',
				yearSelection: [],
				yearCheckAll: false,
				isYearIndeterminate: false,
				isIndeterminate: false,
				stickyBarFixed: false,
				scrollContainer: null,

			}
		},
		computed: {
			filteredFeeTypeCds() {
				return this.simplifyRoomFeeInfo.feeTypeCds.filter(item => item.statusCd !== '888800010008')
			},
			availableMonths() {
				if (!this.simplifyRoomFeeInfo.monthFees) {
					return [];
				}
				return Object.keys(this.simplifyRoomFeeInfo.monthFees);
			},
			sortedAvailableMonths() {
				return [...this.availableMonths].sort((a, b) => {
					const [y1, m1] = a.split('-').map(Number);
					const [y2, m2] = b.split('-').map(Number);
					return y1 * 100 + m1 - (y2 * 100 + m2);
				});
			},
			// 检测是否存在跳月缴费后的历史欠费月（已缴至日期前仍有未缴月份）
			hasHistoricalUnpaid() {
				const months = this.sortedAvailableMonths;
				if (months.length <= 1) return false;

				for (const month of months) {
					const monthData = this.simplifyRoomFeeInfo.monthFees[month];
					if (!Array.isArray(monthData)) continue;

					for (const fee of monthData) {
						const endYM = this.getYearMonthFromDate(fee.endTime);
						if (endYM && endYM > month) {
							return true;
						}
					}
				}
				return false;
			},
			availableYears() {
				const years = new Set();
				this.availableMonths.forEach(m => years.add(m.split('-')[0]));
				return [...years].sort();
			},
			yearChecked() {
				const map = {};
				this.yearSelection.forEach(y => { map[y] = true; });
				return map;
			},
			yearFees() {
				const yearMap = {};
				const monthFees = this.simplifyRoomFeeInfo.monthFees || {};
				Object.keys(monthFees).forEach(monthKey => {
					const year = monthKey.split('-')[0];
					if (!yearMap[year]) {
						yearMap[year] = { feeItems: {}, months: new Set() };
					}
					yearMap[year].months.add(monthKey);
					monthFees[monthKey].forEach(item => {
						const key = item.feeId;
						if (!yearMap[year].feeItems[key]) {
							yearMap[year].feeItems[key] = {
								feeId: item.feeId,
								feeName: item.feeName,
								feeFlagName: item.feeFlagName,
								feeTypeCdName: item.feeTypeCdName,
								feeAttrs: item.feeAttrs || [],
								minMonth: monthKey,
								maxMonth: monthKey,
								totalAmount: 0,
								monthCount: 0
							};
						}
						const fi = yearMap[year].feeItems[key];
						fi.totalAmount += parseFloat(item.receivableAmount || 0);
						fi.monthCount++;
						if (monthKey < fi.minMonth) fi.minMonth = monthKey;
						if (monthKey > fi.maxMonth) fi.maxMonth = monthKey;
					});
				});
				const result = {};
				Object.keys(yearMap).sort().forEach(year => {
					const data = yearMap[year];
					const records = Object.values(data.feeItems).map(fi => ({
						...fi,
						totalAmount: fi.totalAmount.toFixed(2),
						timeRange: fi.minMonth === fi.maxMonth
							? fi.minMonth
							: fi.minMonth + ' ~ ' + fi.maxMonth
					}));
					const yearTotal = records.reduce((sum, r) => sum + parseFloat(r.totalAmount), 0).toFixed(2);
					result[year] = {
						records,
						monthCount: data.months.size,
						yearTotal
					};
				});
				return result;
			}
		},

		mounted() {
			// 找到最近的滚动父容器 (content-panel)
			this.scrollContainer = this.$el.closest('.content-panel');
			if (this.scrollContainer) {
				this.scrollContainer.addEventListener('scroll', this._handleScroll);
			}
		},

		beforeDestroy() {
			if (this.scrollContainer) {
				this.scrollContainer.removeEventListener('scroll', this._handleScroll);
			}
		},

		methods: {

			open(params) {
				this.handleSwitch(params)
			},

			getMonthTotal(monthData) {
				if (!monthData || !Array.isArray(monthData)) {
					return '0.00';
				}
				const total = monthData.reduce((sum, item) => {
					const amount = parseFloat(item.receivableAmount) || 0;
					return sum + amount;
				}, 0);
				return total.toFixed(2);
			},

			// 全选 / 取消全选（按月）
			handleCheckAllChange(checked) {
				this.multipleSelection = checked ? [...this.sortedAvailableMonths] : [];
				this.isIndeterminate = false;
				// 注意：checkAll 由 v-model 自动更新，无需手动设 this.checkAll
			},

			// 全选 / 取消全选（按年）
			handleYearCheckAll(checked) {
				if (checked) {
					const allMonths = [];
					this.availableYears.forEach(year => {
						this.availableMonths.filter(m => m.startsWith(year + '-')).forEach(m => allMonths.push(m));
					});
					allMonths.sort((a, b) => {
						const [y1, m1] = a.split('-').map(Number);
						const [y2, m2] = b.split('-').map(Number);
						return y1 * 100 + m1 - (y2 * 100 + m2);
					});
					this.multipleSelection = allMonths;
					this.yearSelection = [...this.availableYears];
				} else {
					this.multipleSelection = [];
					this.yearSelection = [];
				}
				this.isYearIndeterminate = false;
			},

			// 年度选择变化，同步到 multipleSelection（选年 = 选该年所有月份）
			handleYearSelectionChange(year, checked) {
				const yearMonths = this.availableMonths.filter(m => m.startsWith(year + '-'));
				if (checked) {
					const newMonths = yearMonths.filter(m => !this.multipleSelection.includes(m));
					this.multipleSelection = [...this.multipleSelection, ...newMonths].sort((a, b) => {
						const [y1, m1] = a.split('-').map(Number);
						const [y2, m2] = b.split('-').map(Number);
						return y1 * 100 + m1 - (y2 * 100 + m2);
					});
					if (!this.yearSelection.includes(year)) {
						this.yearSelection = [...this.yearSelection, year].sort();
					}
				} else {
					this.multipleSelection = this.multipleSelection.filter(m => !yearMonths.includes(m));
					this.yearSelection = this.yearSelection.filter(y => y !== year);
				}
				const checkedCount = this.yearSelection.length;
				const totalCount = this.availableYears.length;
				this.yearCheckAll = checkedCount === totalCount;
				this.isYearIndeterminate = checkedCount > 0 && checkedCount < totalCount;
			},

			// 月份选择变化（必须连续，禁止跳选或拆散）
			handleMonthSelectionChange(newVal) {
				const sorted = this.sortedAvailableMonths;
				const prev = this._prevMonthSelection || [];

				if (newVal.length === 0) {
					this.multipleSelection = [];
					this._prevMonthSelection = [];
					this.checkAll = false;
					this.isIndeterminate = false;
					return;
				}

				// 找出新增或移除的月份
				const added = newVal.filter(m => !prev.includes(m));
				const removed = prev.filter(m => !newVal.includes(m));

				let result;

				if (added.length > 0) {
					// === 选中操作：以新增月份为锚点，扩展现有区间 ===
					const allMonths = [...new Set([...newVal, ...prev])];
					let minIdx = sorted.length;
					let maxIdx = -1;
					allMonths.forEach(m => {
						const idx = sorted.indexOf(m);
						if (idx < minIdx) minIdx = idx;
						if (idx > maxIdx) maxIdx = idx;
					});
					result = sorted.slice(minIdx, maxIdx + 1);
				} else if (removed.length > 0) {
					// === 取消操作 ===
					const removedIdx = sorted.indexOf(removed[0]);

					// 找出当前剩余选中的最小/最大索引
					let minIdx = sorted.length;
					let maxIdx = -1;
					newVal.forEach(m => {
						const idx = sorted.indexOf(m);
						if (idx < minIdx) minIdx = idx;
						if (idx > maxIdx) maxIdx = idx;
					});

					if (removedIdx === minIdx - 1 || removedIdx === maxIdx + 1) {
						// 取消的是端点 → 允许，区间收缩
						result = sorted.slice(minIdx, maxIdx + 1);
					} else {
						// 取消的是中间月份 → 不允许拆散，恢复原选择
						result = [...prev];
					}
				} else {
					result = [...newVal];
				}

				if (JSON.stringify(result) !== JSON.stringify(newVal)) {
					this.multipleSelection = [...result];
				}
				this._prevMonthSelection = [...this.multipleSelection];

				const totalCount = sorted.length;
				const cur = this.multipleSelection;
				this.checkAll = cur.length === totalCount;
				this.isIndeterminate = cur.length > 0 && cur.length < totalCount;
			},

			getSelectedMonthData() {
				const selectedData = [];
				this.multipleSelection.forEach(month => {
					if (this.simplifyRoomFeeInfo.monthFees[month]) {
						selectedData.push({
							month: month,
							data: this.simplifyRoomFeeInfo.monthFees[month],
							total: this.getMonthTotal(this.simplifyRoomFeeInfo.monthFees[month])
						});
					}
				});
				return selectedData;
			},

			handleSwitch(param) {
				this.clearSimplifyRoomFeeInfo()
				if (param.roomId === '') return

				Object.assign(this.simplifyRoomFeeInfo, param)

				// 批量缴费后返回时，强制刷新待缴月份列表
				if (sessionStorage.getItem('batchPayFeeSuccess') === 'true') {
					sessionStorage.removeItem('batchPayFeeSuccess')
				}

				this.listSimplifyRoomMonthFee(-1, 10000)

				getDict('pay_fee_config', 'fee_type_cd').then(data => {
					this.simplifyRoomFeeInfo.feeTypeCds = data
				})
			},
			handleNotify() {
				this.listSimplifyRoomMonthFee(-1, 10000)
			},
			getOnePrice1(fee) {
				let price = fee.mwPrice
				if (!price) return fee.squarePrice
				if (parseFloat(price) > 0) return price
				return fee.squarePrice
			},
			async listSimplifyRoomFee(page, row) {
				const params = {
					page,
					row,
					communityId: getCommunityId(),
					payerObjId: this.simplifyRoomFeeInfo.roomId,
					payerObjType: '3333',
					configId: this.simplifyRoomFeeInfo.configId,
					state: this.simplifyRoomFeeInfo.state,
					feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd
				}

				if (this.simplifyRoomFeeInfo.ownerFee === 'Y') {
					params.payerObjId = ''
					params.ownerId = this.simplifyRoomFeeInfo.ownerId
				}

				try {
					const res = await listFee(params)
					this.simplifyRoomFeeInfo.total = res.total
					this.simplifyRoomFeeInfo.records = res.records
					let totalAmount = 0.0

					res.fees.forEach(item => {
						totalAmount += parseFloat(item.amountOwed)
					})

					this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
					this.simplifyRoomFeeInfo.fees = res.fees.sort(this.roomFeeCompare)
					this.total = res.total
				} catch (error) {
					console.error('Failed to fetch fee list:', error)
				}
			},
			roomFeeCompare(a, b) {
				if (a.payerObjName < b.payerObjName) return -1
				if (a.payerObjName > b.payerObjName) return 1
				return 0
			},
			toOwnerPayFee() {
				this.$router.push({
					path: '/views/fee/owePayFeeOrder',
					query: {
						payObjId: this.simplifyRoomFeeInfo.roomId,
						payObjType: '3333',
						roomName: this.simplifyRoomFeeInfo.roomName
					}
				})
			},
			openRoomCreateFeeAddModal() {
				this.simplifyRoomFeeInfo.ownerName = this.simplifyRoomFeeInfo.name
				this.$refs.roomCreateFeeAdd.open({
					isMore: false,
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			openAddMeterWaterSimplifyModal() {
				this.$refs.addMeterWater.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				});
			},
			getAttrValue(attrs, specCd) {
				const attr = attrs.find(item => item.specCd === specCd)
				return attr ? attr.value : ""
			},
			getDeadlineTime(fee) {
				if (fee.amountOwed == 0 && fee.endTime == fee.deadlineTime) return "-"
				if (fee.state == '2009001') return "-"
				return dateFormat(fee.deadlineTime)
			},
			getEndTime(fee) {
				if (fee.state == '2009001') return "-"
				return dateFormat(fee.endTime)
			},
			openProxyFeeModal() {
				this.$refs.addProxyFee.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			payFee(fee) {
				fee.roomName = this.simplifyRoomFeeInfo.roomName
				fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
				this.$router.push({
					path: '/views/fee/payFeeOrder',
					query: {
						feeId: fee.feeId
					}
				})
			},
			editFee(fee) {
				fee.maxEndTime = this.getAttrValue(fee.feeAttrs, '390010')
				this.$refs.editFee.open(fee)
			},
			payFeeHis(fee) {
				fee.builtUpArea = this.simplifyRoomFeeInfo.builtUpArea
				this.$router.push({
					path: '/views/fee/propertyFee',
					query: fee
				})
			},
			deleteFee(fee) {
				this.$refs.deleteFee.open({
					communityId: getCommunityId(),
					feeId: fee.feeId
				})
			},
			finishFee(fee) {
				this.$refs.finishFee.open({
					communityId: getCommunityId(),
					feeId: fee.feeId
				})
			},
			openTempImportRoomFeeModal() {
				this.$refs.tempImportRoomFee.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName,
					ownerName: this.simplifyRoomFeeInfo.name
				})
			},
			openTempFeePayModal() {
				this.$refs.tempFeePay.open({
					roomId: this.simplifyRoomFeeInfo.roomId,
					roomName: this.simplifyRoomFeeInfo.roomName
				})
			},
			clearSimplifyRoomFeeInfo() {
				const feeConfigs = this.simplifyRoomFeeInfo.feeConfigs
				this.simplifyRoomFeeInfo = {
					total: 0,
					records: 1,
					fees: [],
					monthFees: [],
					accounts: [],
					roomId: '',
					name: '',
					roomName: '',
					floorNum: '',
					unitNum: '',
					roomNum: '',
					feeConfigs: feeConfigs,
					feeTypeCd: '',
					configId: '',
					state: '2008001',
					totalAmount: 0.0,
					roomType: '',
					ownerFee: 'N',
					ownerId: '',
					showFlag: 'MONTH'
				}
				this.multipleSelection = [];
				this._prevMonthSelection = [];
				this.checkAll = false;
				this.isIndeterminate = false;
				this.yearSelection = [];
				this.yearCheckAll = false;
				this.isYearIndeterminate = false;
			},
			changeSimplifyRoomFeeFeeTypeCd(feeTypeCd) {
				this.simplifyRoomFeeInfo.configId = ''
				this.$emit('notify', {})

				const params = {
					page: 1,
					row: 50,
					communityId: getCommunityId(),
					feeTypeCd: feeTypeCd,
					isDefault: '',
					valid: '1'
				}

				listFeeConfigs(params).then(res => {
					this.simplifyRoomFeeInfo.feeConfigs = res.feeConfigs
				}).catch(error => {
					console.error('Failed to fetch fee configs:', error)
				})
			},
			changeSimplifyRoomConfigId() {
				this.$emit('notify', {})
			},
			simplifyRoomGetFeeOwnerInfo(attrs) {
				const ownerName = this.getAttrValue(attrs, '390008')
				const ownerLink = this.getAttrValue(attrs, '390009')
				return `业主：${ownerName},电话：${ownerLink}`
			},
			getSimplifyRoomFeeRoomName(fee) {
				if (this.simplifyRoomFeeInfo.ownerFee != 'Y') return ''

				const attr = fee.feeAttrs.find(item => item.specCd === '390012')
				return attr ? `(${attr.value})` : ''
			},
			openBatchPayRoomFeeModal() {
				if (this.haveHistory) {
					alert("该用户存在历史性欠费，请先缴清历史性欠费。");
					this.toOwnerPayFee();
					return;
				}

				// 统计 feeId 出现次数 + 最早/最晚的选中月份（用于跳选月份时正确计算缴费时段）
				const feeIdInfoMap = {};

				this.multipleSelection.forEach(month => {
					const monthData = this.simplifyRoomFeeInfo.monthFees[month];
					if (Array.isArray(monthData)) {
						monthData.forEach(item => {
							if (item.feeId) {
								if (!feeIdInfoMap[item.feeId]) {
									feeIdInfoMap[item.feeId] = { count: 0, earliestMonth: '', latestMonth: '' };
								}
								feeIdInfoMap[item.feeId].count++;
								// 记录最早出现的月份
								if (!feeIdInfoMap[item.feeId].earliestMonth || month < feeIdInfoMap[item.feeId].earliestMonth) {
									feeIdInfoMap[item.feeId].earliestMonth = month;
								}
								// 记录最晚出现的月份
								if (month > feeIdInfoMap[item.feeId].latestMonth) {
									feeIdInfoMap[item.feeId].latestMonth = month;
								}
							}
						});
					}
				});

				const feeIdCountList = Object.entries(feeIdInfoMap).map(([feeId, info]) => ({
					feeId,
					count: info.count,
					earliestMonth: info.earliestMonth,
					latestMonth: info.latestMonth
				}));

				if (feeIdCountList.length === 0) {
					this.$message.warning(this.viewMode === 'year' ? '请至少选择一年进行缴费' : '请至少选择一个月份进行缴费');
					return;
				}

				// ✅ 方案：通过 sessionStorage 传递（避免 URL 过长 + 支持复杂结构）
				sessionStorage.setItem('batchPayFeeIdCounts', JSON.stringify(feeIdCountList));

				this.$router.push({
					path: '/views/fee/batchPayFeeOrder',
					query: {
						ownerId: this.simplifyRoomFeeInfo.ownerId,
						payerObjType: '3333'
					}
				});
			},
			openMonthPayRoomFeeModal() {
				this.$router.push({
					path: '/property/payFeeMonthOrder',
					query: {
						payerObjId: this.simplifyRoomFeeInfo.roomId,
						payerObjType: '3333'
					}
				})
			},
			openRoomCreateFeeComboModal() {
				this.$router.push({
					path: '/views/fee/createFeeByCombo',
					query: {
						payerObjId: this.simplifyRoomFeeInfo.roomId,
						payerObjName: this.simplifyRoomFeeInfo.roomName,
						payerObjType: '3333'
					}
				})
			},
			viewRoomFeeConfig(fee) {
				const params = {
					page: 1,
					row: 1,
					communityId: getCommunityId(),
					configId: fee.configId
				}

				listFeeConfigs(params).then(res => {
					const feeConfig = res.feeConfigs[0]
					this.$emit('openViewDataModal', {
						title: `${fee.feeName} 费用项`,
						data: {
							"费用项ID": feeConfig.configId,
							"费用类型": feeConfig.feeTypeCdName,
							"收费项目": feeConfig.feeName,
							"费用标识": feeConfig.feeFlagName,
							"催缴类型": feeConfig.billTypeName,
							"付费类型": feeConfig.paymentCd == '1200' ? '预付费' : '后付费',
							"缴费周期": feeConfig.paymentCycle,
							"应收开始时间": feeConfig.startTime,
							"应收结束时间": feeConfig.endTime,
							"公式": feeConfig.computingFormulaName,
							"计费单价": feeConfig.computingFormula == '2002' ? '-' : feeConfig.squarePrice,
							"附加/固定费用": feeConfig.additionalAmount
						}
					})
				}).catch(error => {
					console.error('Failed to fetch fee config:', error)
				})
			},
			viewRoomFee(fee) {
				const data = {
					"费用ID": fee.feeId,
					"费用标识": fee.feeFlagName,
					"费用类型": fee.feeTypeCdName,
					"付费对象": fee.payerObjName,
					"费用项": fee.feeName,
					"费用状态": fee.stateName,
					"建账时间": fee.startTime,
					"应收开始时间": this.getEndTime(fee),
					"应收结束时间": this.getDeadlineTime(fee),
					"批次": fee.batchId
				}

				fee.feeAttrs.forEach(attr => {
					data[attr.specCdName] = attr.value
				})

				this.$emit('openViewDataModal', {
					title: `${fee.feeName} 详情`,
					data: data
				})
			},
			changeSimplifyRoomShowFlag() {
				if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
					this.listSimplifyRoomMonthFee(-1, 10000)
				} else {
					this.listSimplifyRoomFee(1, this.pageSize)
				}
			},
			async listSimplifyRoomMonthFee(page, row) {
				const params = {
					page,
					row,
					communityId: getCommunityId(),
					objId: this.simplifyRoomFeeInfo.roomId,
					payerObjType: '3333',
					configId: this.simplifyRoomFeeInfo.configId,
					feeTypeCd: this.simplifyRoomFeeInfo.feeTypeCd,
					detailId: '-1',
					feeState: '2008001'
				}

				if (this.simplifyRoomFeeInfo.ownerFee == 'Y') {
					params.payerObjId = ''
					params.ownerId = this.simplifyRoomFeeInfo.ownerId
				}

				try {
					const res = await listMonthFee(params)
					this.simplifyRoomFeeInfo.total = res.total
					this.simplifyRoomFeeInfo.records = res.records
					let totalAmount = 0.0
					this.haveHistory = false; // 重置历史欠费标志
					res.data.forEach(item => {
						totalAmount += parseFloat(item.receivableAmount)
						if (item.remark == '历史费用') {
							this.haveHistory = true;
						}
					})
					this.simplifyRoomFeeInfo.totalAmount = totalAmount.toFixed(2)
					this.simplifyRoomFeeInfo.monthFees = groupByYearMonthWithMap(res.data)
					// 重置选择状态
					this.multipleSelection = [];
					this._prevMonthSelection = [];
					this.checkAll = false;
					this.isIndeterminate = false;
					// 数据刷新后，重置 fixed 状态并恢复到正常流
					if (this.stickyBarFixed) {
						const el = this.$refs.stickyBar;
						this.stickyBarFixed = false;
						if (el) {
							el.style.width = '';
							el.style.left = '';
							const placeholder = el.nextElementSibling;
							if (placeholder && placeholder.classList.contains('sticky-bar-placeholder')) {
								placeholder.style.height = '';
							}
						}
					}
					this.$nextTick(() => {
						if (this.scrollContainer) {
							this.scrollContainer.scrollTop = 0;
						}
					});

				} catch (error) {
					console.error('Failed to fetch month fee list:', error)
				}
			},
			handleCurrentChange(page) {
				this.currentPage = page
				if (this.simplifyRoomFeeInfo.showFlag == 'MONTH') {
					this.listSimplifyRoomMonthFee(-1, 10000)
				} else {
					this.listSimplifyRoomFee(page, this.pageSize)
				}
			},
			parseYearMonth(ym) {
				if (!ym || typeof ym !== 'string') return 0;
				const [year, month] = ym.split('-').map(Number);
				return year * 100 + month;
			},
			getYearMonthFromDate(dateVal) {
				if (!dateVal) return '';
				const d = new Date(dateVal);
				if (isNaN(d.getTime())) return '';
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				return `${y}-${m}`;
			},

			_handleScroll() {
				if (!this.$refs.stickyBar || !this.scrollContainer) return;
				const el = this.$refs.stickyBar;
				const containerRect = this.scrollContainer.getBoundingClientRect();

				if (this.stickyBarFixed) {
					// 已固定：通过占位元素（留在正常流中）的位置判断是否应该解除固定
					const placeholder = el.nextElementSibling;
					if (placeholder && placeholder.classList.contains('sticky-bar-placeholder')) {
						const placeholderTop = placeholder.getBoundingClientRect().top;
						// 占位元素顶部 >= 容器顶部 → 说明已滚动回原位，解除固定
						if (placeholderTop >= containerRect.top) {
							this.stickyBarFixed = false;
							el.style.width = '';
							el.style.left = '';
							placeholder.style.height = '';
						}
					}
				} else {
					// 未固定：bar 滚出容器顶部时固定
					const barTop = el.getBoundingClientRect().top;
					if (barTop < containerRect.top) {
						this.stickyBarFixed = true;
						el.style.width = containerRect.width + 'px';
						el.style.left = containerRect.left + 'px';
						const placeholder = el.nextElementSibling;
						if (placeholder && placeholder.classList.contains('sticky-bar-placeholder')) {
							placeholder.style.height = el.offsetHeight + 'px';
						}
					}
				}
			},

		}
	}
</script>

<style scoped>
	.margin-top-lg {
		margin-top: 20px;
	}

	.margin-top {
		margin-top: 15px;
	}

	.text-right {
		text-align: right;
	}

	.sticky-action-bar {
		z-index: 100;
		background: #fff;
	}

	.sticky-action-bar.is-fixed {
		position: fixed;
		top: 0;
		right: 20px;
		z-index: 100;
		background: #fff;
		padding: 10px 20px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.sticky-bar-placeholder {
		visibility: hidden;
	}

	.hand {
		cursor: pointer;
	}

	.year-section {
		border: 1px solid #ebeef5;
		border-radius: 4px;
		overflow: hidden;
	}
</style>